<template>
	<HeroLayout v-model="showContactUs">
		<div class="flex flex-col w-full h-full">
			<p class="registration-title mt-11 mb-10 text-heading">Add profile information</p>

			<form>
				<InputText label="First name*" class="userpilot-mask" type="text" placeholder="Enter your first name"
							  v-model="first_name" :errors="error" :error-field="'user.given_name'" />

				<InputText label="Last name*" type="text" placeholder="Enter your last name"
							  v-model="last_name" :errors="error" :error-field="'user.family_name'"
							  class="userpilot-mask mt-8" />

				<InputText label="Phone number*" type="tel" autocomplete="tel" placeholder="Enter 10-digit number, U.S. only, for example (999) 999-9999"
							  v-model="phone_number" v-maska:phone_number_unmasked.unmasked="'(###) ###-####'"
							  class="userpilot-mask mt-8" :errors="error" :error-field="'user.phone_number'" />

				<check-box class="mt-8 font-bold" v-model="receive_sms" @click.prevent="receive_sms = !receive_sms"
							  label="I would like to receive SMS notifications to the phone number provided. Message and data rates may apply." />

				<SubmitButton class="ml-auto mt-10" label="Next" :loading="isLoading" @click="updateProfile" />
				<ValidationError :errors="error" :field="null" />
			</form>
		</div>
	</HeroLayout>
</template>

<script setup lang="js">
import { ref } from 'vue'
import InputText from '@/components/Forms/InputText.vue'
import ValidationError from '@/components/Forms/InputError.vue'
import { vMaska } from 'maska/vue'
import { userApi } from '@/api/User/UserApi.js'
import { useAuthStore } from '@/stores/authStore.js'
import CheckBox from '@/components/Forms/CheckBox.vue'
import router from '@/router/router.js'
import HeroLayout from '@/layouts/HeroLayout.vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'

const isLoading = ref(false)
const error = ref(null)
const user = useAuthStore().getAuth?.user()
const first_name = ref(user?.given_name)
const last_name = ref(user?.family_name)
const phone_number = ref(user?.phone_number)
const phone_number_unmasked = ref('')
const receive_sms = ref(false)
const showContactUs = ref(false)

defineExpose({ phone_number_unmasked })

function updateProfile()
{
	error.value = null
	isLoading.value = true

	userApi.update({
		'user': {
			'id': user.id,
			'email': user.email,
			'given_name': first_name.value,
			'family_name': last_name.value,
			'phone_number': phone_number_unmasked.value,
			'receive_sms': receive_sms.value
		}
	}, (response) =>
	{
		const authStore = useAuthStore()
		authStore.handleLoginResult(response.body(), user.email, user.password)

		authStore.userpilotIdentify();

		if (authStore.userOrganizations.length > 0)
		{
			router.push({ name: 'auth.login-success' })
		}
		else
		{
			router.push({ name: 'auth.find-organization' })
		}
	}, (e) =>
	{
		isLoading.value = false
		error.value = e.showErrorBanner()
	})
}

</script>
